import type {
  EnvConfigBrand,
  EnvConfigSegment,
  EnvConfigType,
} from '@core/config-models';

/**
 * Checks if the given brand/segment/type combination matches the current environment.
 * Supports arrays of each property to allow multiple values for each property to pass
 */
export function isBrandSegmentType({
  brand,
  segment,
  type,
  currentBrand,
  currentSegment,
  currentType,
}: {
  brand: EnvConfigBrand | EnvConfigBrand[];
  segment: EnvConfigSegment | EnvConfigSegment[];
  type: EnvConfigType | EnvConfigType[];
  currentBrand?: EnvConfigBrand;
  currentSegment?: EnvConfigSegment;
  currentType?: EnvConfigType;
}): boolean {
  if (!currentBrand || !currentSegment || !currentType) {
    return false;
  }

  return (
    (Array.isArray(brand)
      ? brand.includes(currentBrand)
      : brand === currentBrand) &&
    (Array.isArray(segment)
      ? segment.includes(currentSegment)
      : segment === currentSegment) &&
    (Array.isArray(type) ? type.includes(currentType) : type === currentType)
  );
}
